import { formatProgDetails } from '../helpers';
import { FETCH_HOME_CATEGORIES, FETCH_HOME_CATEGORIES_IS_LOADING, FETCH_HOME_CATEGORIES_HAS_ERRORED, FETCH_HOME_CATEGORIES_LIST, FETCH_HOME_CATEGORIES_LIST_IS_LOADING, FETCH_HOME_CATEGORIES_LIST_HAS_ERRORED } from './types';
import { globalFetch } from './globalActions';

///////////
// Home Page Categories //
///////////

/* Get the list of categories selected for the homepage */
export function fetchCatHomeList() {
	return globalFetch({
			urlPath: `homePageCategories`,
			urlSrc: 1,
			reducerIsLoading: FETCH_HOME_CATEGORIES_LIST_IS_LOADING,
			reducerError: FETCH_HOME_CATEGORIES_LIST_HAS_ERRORED,
			dispatchSuccess: (itemObj, dispatch) => {
				dispatch(fetchCatHomeListSuccess(itemObj));
			}
	});
}

export function fetchCatHomeListSuccess(items) {
	return { type: FETCH_HOME_CATEGORIES_LIST, payload: items.categories };
}


/* Get the actual programmes from the category */
export function fetchCatHome(id=0) {
	return globalFetch({
			urlPath: `programme_feed_by_category`,
			extraParams: `&id=${ id }`,
			reducerIsLoading: FETCH_HOME_CATEGORIES_IS_LOADING,
			reducerError: FETCH_HOME_CATEGORIES_HAS_ERRORED,
			dispatchSuccess: (itemObj, dispatch) => {
					dispatch(fetchCatHomeSuccess(itemObj, id));
			}
	});
}

export function fetchCatHomeSuccess(items, catId) {
	let cardItems = [];
	if(Object.keys(items.progs).length > 0)
	{
		Object.entries(items.progs).forEach(([key, value]) => {
		  cardItems[key] = formatProgDetails(value);
			cardItems[key].isActions = true;
			cardItems[key].billing = value.short_billing;

		});
		cardItems.catId = catId;
	}
	return { type: FETCH_HOME_CATEGORIES, items: cardItems };
}
